import React from 'react';
import { ChevronDown, ChevronUp, Sparkles } from 'lucide-react';
import { AddonsSelector } from './AddonsSelector';

function CollapsibleSection({ title, icon: Icon, isOpen, onToggle, badge, children }) {
  return (
    <div className="border border-white/10 rounded-xl overflow-hidden bg-gradient-to-b from-[#1a1f50]/50 to-[#080c2d]/50">
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between p-4 hover:bg-white/5 transition-colors"
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#aa2aff] to-[#7012b2] flex items-center justify-center">
            <Icon className="w-5 h-5 text-white" />
          </div>
          <span className="text-white font-semibold text-lg">{title}</span>
          {badge && (
            <span className="px-2 py-0.5 text-xs font-bold bg-[#aa2aff]/20 text-[#aa2aff] rounded-full">
              {badge}
            </span>
          )}
        </div>
        {isOpen ? (
          <ChevronUp className="w-5 h-5 text-slate-400" />
        ) : (
          <ChevronDown className="w-5 h-5 text-slate-400" />
        )}
      </button>
      
      {isOpen && (
        <div className="p-4 pt-0 border-t border-white/5">
          {children}
        </div>
      )}
    </div>
  );
}

export function ServiciosAdicionalesSection({
  isOpen,
  onToggle,
  selectedDistribution,
  selectedBooktrailer,
  selectedLegalKit,
  selectedCoverDesign,
  selectedBrandingPack,
  selectedMusicStock,
  musicStockQuantity = 1,
  selectedConsultoria,
  consultoriaQuantity = 1,
  // New services
  selectedQrDinamico,
  selectedEnlaceGo,
  selectedNfcVcard,
  selectedSeparadores,
  selectedPreventa,
  selectedBannerPromotion,
  bannerPromotionMonths = 1,
  selectedDisenoWebBanner,
  selectedPhotoshoot,
  selectedPaginaAutor,
  selectedPautajeDigital,
  // Callbacks
  onDistributionChange,
  onBooktrailerChange,
  onLegalKitChange,
  onCoverDesignChange,
  onBrandingPackChange,
  onMusicStockChange,
  onMusicStockQuantityChange,
  onConsultoriaChange,
  onConsultoriaQuantityChange,
  onQrDinamicoChange,
  onEnlaceGoChange,
  onNfcVcardChange,
  onSeparadoresChange,
  onPreventaChange,
  onBannerPromotionChange,
  onBannerPromotionMonthsChange,
  onDisenoWebBannerChange,
  onPhotoshootChange,
  onPaginaAutorChange,
  onPautajeDigitalChange,
  onTarjetasChange,
  onSeparadoresImpresosChange,
  onEnvioChange,
  revisionAudio,
  onRevisionAudioChange,
  masterizacion,
  onMasterizacionChange,
  selectedTarjetas,
  selectedSeparadoresImpresos,
  selectedEnvio,
  formatPrice,
  currency,
  addonsTotal = 0,
  servicePrices = {},
  editorialSection = null
}) {
  const badge = addonsTotal > 0 ? formatPrice(addonsTotal) : null;

  return (
    <CollapsibleSection
      title="Servicios Adicionales"
      icon={Sparkles}
      isOpen={isOpen}
      onToggle={onToggle}
      badge={badge}
    >
      <div className="space-y-2">
        <p className="text-slate-400 text-sm mb-4">
          Estos servicios se pueden contratar de forma independiente o junto con Audiolibro/Podcast.
        </p>
        <AddonsSelector
          selectedDistribution={selectedDistribution}
          selectedBooktrailer={selectedBooktrailer}
          selectedLegalKit={selectedLegalKit}
          selectedCoverDesign={selectedCoverDesign}
          selectedBrandingPack={selectedBrandingPack}
          selectedMusicStock={selectedMusicStock}
          musicStockQuantity={musicStockQuantity}
          selectedConsultoria={selectedConsultoria}
          consultoriaQuantity={consultoriaQuantity}
          selectedQrDinamico={selectedQrDinamico}
          selectedEnlaceGo={selectedEnlaceGo}
          selectedNfcVcard={selectedNfcVcard}
          selectedSeparadores={selectedSeparadores}
          selectedPreventa={selectedPreventa}
          selectedBannerPromotion={selectedBannerPromotion}
          bannerPromotionMonths={bannerPromotionMonths}
          selectedDisenoWebBanner={selectedDisenoWebBanner}
          selectedPhotoshoot={selectedPhotoshoot}
          selectedPaginaAutor={selectedPaginaAutor}
          selectedPautajeDigital={selectedPautajeDigital}
          onDistributionChange={onDistributionChange}
          onBooktrailerChange={onBooktrailerChange}
          onLegalKitChange={onLegalKitChange}
          onCoverDesignChange={onCoverDesignChange}
          onBrandingPackChange={onBrandingPackChange}
          onMusicStockChange={onMusicStockChange}
          onMusicStockQuantityChange={onMusicStockQuantityChange}
          onConsultoriaChange={onConsultoriaChange}
          onConsultoriaQuantityChange={onConsultoriaQuantityChange}
          onQrDinamicoChange={onQrDinamicoChange}
          onEnlaceGoChange={onEnlaceGoChange}
          onNfcVcardChange={onNfcVcardChange}
          onSeparadoresChange={onSeparadoresChange}
          onPreventaChange={onPreventaChange}
          onBannerPromotionChange={onBannerPromotionChange}
          onBannerPromotionMonthsChange={onBannerPromotionMonthsChange}
          onDisenoWebBannerChange={onDisenoWebBannerChange}
          onPhotoshootChange={onPhotoshootChange}
          onPaginaAutorChange={onPaginaAutorChange}
          onPautajeDigitalChange={onPautajeDigitalChange}
          onTarjetasChange={onTarjetasChange}
          onSeparadoresImpresosChange={onSeparadoresImpresosChange}
          onEnvioChange={onEnvioChange}
          revisionAudio={revisionAudio}
          onRevisionAudioChange={onRevisionAudioChange}
          masterizacion={masterizacion}
          onMasterizacionChange={onMasterizacionChange}
          selectedTarjetas={selectedTarjetas}
          selectedSeparadoresImpresos={selectedSeparadoresImpresos}
          selectedEnvio={selectedEnvio}
          formatPrice={formatPrice}
          currency={currency}
          servicePrices={servicePrices}
        />
        {/* Editorial Services inside Servicios Adicionales */}
        {editorialSection && (
          <div className="mt-4 pt-4 border-t border-white/10">
            {editorialSection}
          </div>
        )}
      </div>
    </CollapsibleSection>
  );
}

export default ServiciosAdicionalesSection;
